const INT_V2_HASURA_ENDPOINT = "control-int-gql-auto-readonly.debesys.net/v1/graphql";
const INT_V2_US_HASURA_ENDPOINT = "control-int-gql-us-readonly.debesys.net/v1/graphql";
const INT_V2_EU_HASURA_ENDPOINT = "control-int-gql-eu-readonly.debesys.net/v1/graphql";

const EXT_V2_HASURA_ENDPOINT = "control-ext-gql-auto-readonly.trade.tt/v1/graphql";
const EXT_V2_US_HASURA_ENDPOINT = "control-ext-gql-us-readonly.trade.tt/v1/graphql";
const EXT_V2_EU_HASURA_ENDPOINT = "control-ext-gql-eu-readonly.trade.tt/v1/graphql"

const LITE_V2_HASURA_ENDPOINT = "control-ext-gql-lite.trade.tt/v1/graphql";


export const envConfig = {
  'local': {
    default_env: 'int-dev-sim',
    prefix_env: 'int',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'int',
    t3_url: 'https://triage-dev.debesys.net',
    graphql_us_uri: INT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: INT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: INT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: 'availability-dev.debesys.net',
    lite: false,
    header: "Control (LOCAL-INT)",
  },
  'local-lite': {
    default_env: 'int-dev-sim',
    prefix_env: 'int',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'prod',
    t3_url: '',
    graphql_us_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_eu_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: '',
    lite: true,
    header: "Control (LOCAL-LITE)",
  },
  'local-prod': {
    default_env: 'int-dev-sim',
    prefix_env: 'ext-prod',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'local-prod',
    t3_url: 'https://triage-dev.debesys.net',
    graphql_us_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_eu_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: 'availability.debesys.net',
    lite: false,
    header: "Control (LOCAL-PROD)",
  },
  'local-preview': {
    default_env: 'int-dev-sim',
    prefix_env: 'int',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'int',
    t3_url: 'https://triage-lab-int.debesys.net',
    graphql_us_uri: INT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: INT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: INT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: 'availability-dev.debesys.net',
    lite: false,
  },
  'int-dev': {
    default_env: 'int-dev-sim',
    prefix_env: 'int',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'int',
    t3_url: 'https://triage-dev.debesys.net',
    graphql_us_uri: INT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: INT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: INT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: 'availability-dev.debesys.net',
    lite: false,
    header: "Control (INT)",
  },
  'int-dev-us': {
    default_env: 'int-dev-sim',
    prefix_env: 'int',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'int',
    t3_url: 'https://triage-dev.debesys.net',
    graphql_us_uri: INT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: INT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: INT_V2_US_HASURA_ENDPOINT,
    graphql_default: "graphql_us_uri",
    availability_url: 'availability-dev.debesys.net',
    lite: false,
    header: "Control (INT) us-east-1",
  },
  'int-dev-eu': {
    default_env: 'int-dev-sim',
    prefix_env: 'int',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'int',
    t3_url: 'https://triage-dev.debesys.net',
    graphql_us_uri: INT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: INT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: INT_V2_EU_HASURA_ENDPOINT,
    graphql_default: "graphql_eu_uri",
    availability_url: 'availability-dev.debesys.net',
    lite: false,
    header: "Control (INT) eu-west-1",
  },
  'int-preview-lite': {
    default_env: 'ext-prod-live',
    prefix_env: 'ext-prod',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'int',
    t3_url: '',
    graphql_us_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_eu_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: '',
    lite: true,
    header: "Control (LITE-PREVIEW)",
  },
  'ext-prod': {
    default_env: 'ext-prod-live',
    prefix_env: 'ext-prod',
    titlebar_url: 'https://auth.trade.tt/',
    titlebar_name: 'prod',
    t3_url: 'https://triage.debesys.net',
    graphql_us_uri: EXT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: EXT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: EXT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: 'availability.debesys.net',
    lite: false,
    header: "Control (PROD)",
  },
  'ext-prod-us': {
    default_env: 'ext-prod-live',
    prefix_env: 'ext-prod',
    titlebar_url: 'https://auth.trade.tt/',
    titlebar_name: 'prod',
    t3_url: 'https://triage.debesys.net',
    graphql_us_uri: EXT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: EXT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: EXT_V2_US_HASURA_ENDPOINT,
    graphql_default: "graphql_us_uri",
    availability_url: 'availability.debesys.net',
    lite: false,
    header: "Control (PROD)",
  },
  'ext-prod-eu': {
    default_env: 'ext-prod-live',
    prefix_env: 'ext-prod',
    titlebar_url: 'https://auth.trade.tt/',
    titlebar_name: 'prod',
    t3_url: 'https://triage.debesys.net',
    graphql_us_uri: EXT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: EXT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: EXT_V2_EU_HASURA_ENDPOINT,
    graphql_default: "graphql_eu_uri",
    availability_url: 'availability.debesys.net',
    lite: false,
    header: "Control (PROD)",
  },
  'ext-prod-preview': {
    default_env: 'ext-prod-live',
    prefix_env: 'ext-prod',
    titlebar_url: 'https://auth.trade.tt/',
    titlebar_name: 'prod',
    t3_url: 'https://triage.debesys.net',
    graphql_us_uri: EXT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: EXT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: EXT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: 'availability.debesys.net',
    lite: false,
    header: "Control (PROD-PREVIEW)",
  },
  'ext-uat': {
    default_env: 'ext-uat-cert',
    prefix_env: 'ext-uat',
    titlebar_url: 'https://auth-uat.trade.tt/',
    titlebar_name: 'uat',
    t3_url: 'https://triage.debesys.net',
    graphql_us_uri: EXT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: EXT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: EXT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: 'availability.debesys.net',
    lite: false,
    header: "Control (UAT)",
  },
  'ext-uat-us': {
    default_env: 'ext-uat-cert',
    prefix_env: 'ext-uat',
    titlebar_url: 'https://auth-uat.trade.tt/',
    titlebar_name: 'uat',
    t3_url: 'https://triage.debesys.net',
    graphql_us_uri: EXT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: EXT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: EXT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_us_uri",
    availability_url: 'availability.debesys.net',
    lite: false,
    header: "Control (UAT)",
  },
  'ext-uat-eu': {
    default_env: 'ext-uat-cert',
    prefix_env: 'ext-uat',
    titlebar_url: 'https://auth-uat.trade.tt/',
    titlebar_name: 'uat',
    t3_url: 'https://triage.debesys.net',
    graphql_us_uri: EXT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: EXT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: EXT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_eu_uri",
    availability_url: 'availability.debesys.net',
    lite: false,
    header: "Control (UAT)",
  },
  'ext-lite': {
    default_env: 'ext-prod-live',
    prefix_env: 'ext-prod',
    titlebar_url: 'https://auth.trade.tt/',
    titlebar_name: 'prod',
    t3_url: '',
    graphql_us_uri: EXT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: EXT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: LITE_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: '',
    lite: true,
    header: "Control (LITE)",
  },
  'int-preview': {
    default_env: 'int-dev-sim',
    prefix_env: 'int',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'int',
    t3_url: 'https://triage-lab-int.debesys.net',
    graphql_us_uri: INT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: INT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: INT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_uri",
    availability_url: 'availability-dev.debesys.net',
    lite: false,
    header: "Control (PREVIEW)",
  },
  'int-preview-us': {
    default_env: 'int-dev-sim',
    prefix_env: 'int',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'int',
    t3_url: 'https://triage-lab-int.debesys.net',
    graphql_us_uri: INT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: INT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: INT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_us_uri",
    availability_url: 'availability-dev.debesys.net',
    lite: false,
    header: "Control (PREVIEW) us-east-1",
  },
  'int-preview-eu': {
    default_env: 'int-dev-sim',
    prefix_env: 'int',
    titlebar_url: 'https://auth-int-dev.trade.tt/',
    titlebar_name: 'int',
    t3_url: 'https://triage-lab-int.debesys.net',
    graphql_us_uri: INT_V2_US_HASURA_ENDPOINT,
    graphql_eu_uri: INT_V2_EU_HASURA_ENDPOINT,
    graphql_uri: INT_V2_HASURA_ENDPOINT,
    graphql_default: "graphql_eu_uri",
    availability_url: 'availability-dev.debesys.net',
    lite: false,
    header: "Control (PREVIEW) eu-west-1",
  },
}

export default envConfig
